import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { Typography } from 'antd';

import ActionCollapse from 'v2/components/Shared/QuickView/ActionCollapse';
import type { IContentDelivery } from 'v2/interfaces/product';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import { dateService } from 'v2/services/date';
import productService from 'v2/services/product';

import { Icon } from '@eduzz/ui-antd-theme';

import BankSlipInstallment from './bankSlipIntallment';
import { BuyerDetails } from './buyerDetails';
import GetCcbTerm from './CcbTerm/getCcbTerm';
import { ChangePaymentMethod } from './changePaymentMethod';
import FiscalDocument from './fiscalDocument';
import InvoiceDetails from './invoiceDetails';
import { PaymentHistory } from './paymentHistory';

interface JobProductProps {
  delivery: ShoppingDelivery;
  closeQuickView: () => void;
}

const JobProduct = ({ delivery, closeQuickView }: JobProductProps) => {
  const [contentDelivery, setContentDelivery] = React.useState<IContentDelivery>({
    delivery_nutror: false,
    download_hash: false
  });

  useEffect(() => {
    const fetchContentDelivery = async () => {
      setContentDelivery(await productService.getContentDelivery(delivery.product.id));
    };

    fetchContentDelivery();
  }, [delivery.product.id]);

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex items-start gap-3'>
        <img
          className='size-16 shrink-0 rounded bg-(--uizz-antd-color-fill-tertiary) object-cover'
          src={delivery.product.image}
          alt={delivery.product.title}
        />

        <div>
          <Typography.Text className='block'>{delivery.product.title}</Typography.Text>
          {delivery.order.status && <Typography.Text type='success'>{delivery.order.status}</Typography.Text>}
        </div>
      </div>

      <BuyerDetails delivery={delivery} />

      <div className='flex flex-col gap-1'>
        <div className='text-sm'>
          <Typography.Text>Criação: </Typography.Text>
          <Typography.Text type='secondary'>
            {dateService.dateToString(new Date(delivery.created_at), 'dd/MM/yyyy HH:mm')}
          </Typography.Text>
        </div>
        <div className='text-sm'>
          <Typography.Text>Previsão de entrega: </Typography.Text>
          <Typography.Text type='secondary'>
            {delivery.order.expected_date
              ? dateService.dateToString(new Date(delivery.order.expected_date), 'dd/MM/yyyy HH:mm')
              : '-'}
          </Typography.Text>
        </div>
        <div className='text-sm'>
          <Typography.Text>Entrega: </Typography.Text>
          <Typography.Text type='secondary'>
            {delivery.order.delivery_date
              ? dateService.dateToString(new Date(delivery.order.delivery_date), 'dd/MM/yyyy HH:mm')
              : '-'}
          </Typography.Text>
        </div>
      </div>

      {!delivery.unlimited_installment && !delivery?.bankslip_installments && <InvoiceDetails delivery={delivery} />}

      {!delivery.unlimited_installment && delivery?.bankslip_installments && (
        <BankSlipInstallment delivery={delivery} />
      )}

      {delivery.unlimited_installment && <PaymentHistory delivery={delivery} />}

      <FiscalDocument delivery={delivery} />

      {contentDelivery.download_hash && (
        <Link className='text-center' to={`/downloads/${contentDelivery.download_hash}`} target='_blank'>
          Download Materiais
        </Link>
      )}

      {delivery.unlimited_installment && <ChangePaymentMethod delivery={delivery} closeQuickView={closeQuickView} />}

      <ActionCollapse title='Contato com Produtor' icon={<Icon.User size={16} />}>
        <div className='flex flex-col gap-1'>
          {delivery.producer.name && (
            <div className='text-sm'>
              <Typography.Text>Nome: </Typography.Text>
              <Typography.Text type='secondary'>{delivery.producer.name}</Typography.Text>
            </div>
          )}
          {delivery.producer.email && (
            <div className='text-sm'>
              <Typography.Text>E-mail: </Typography.Text>
              <Typography.Text type='secondary'>{delivery.producer.email}</Typography.Text>
            </div>
          )}
          {delivery.producer.phone && (
            <div className='text-sm'>
              <Typography.Text>Telefone: </Typography.Text>
              <Typography.Text type='secondary'>{delivery.producer.phone}</Typography.Text>
            </div>
          )}
          {delivery.producer.address && (
            <div className='text-sm'>
              <Typography.Text>Endereço: </Typography.Text>
              <Typography.Text type='secondary'>{delivery.producer.address}</Typography.Text>
            </div>
          )}
        </div>
      </ActionCollapse>

      <GetCcbTerm delivery={delivery} />
    </div>
  );
};

export default JobProduct;
